import { render } from "./UETreatmentBenefitEditView.vue?vue&type=template&id=1da4f03d&scoped=true"
import script from "./UETreatmentBenefitEditView.vue?vue&type=script&lang=js"
export * from "./UETreatmentBenefitEditView.vue?vue&type=script&lang=js"

import "./UETreatmentBenefitEditView.vue?vue&type=style&index=0&id=1da4f03d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da4f03d"]])

export default __exports__